
define('eteration/widgets/ui-multicity-booker',[ 'knockout', 'eteration/widgets/widget-util', 'text!eteration/widgets/template/template-multicity-booker.html', 'moment' , 'underscore' , 'eteration/widgets/ui-booker-datepicker' ], function(ko, widgetUtil, templateMulticityBooker, moment, underscore) {

	widgetUtil.setupStringBasedTemplate(ko);

	ko.templates["multicity-booker"] = templateMulticityBooker; 
	
	ko.bindingHandlers['multicity-booker'] = {

		makeTemplateValueAccessor : function(valueAccessor, allBindings, element) {
			var templateData = {};
			templateData.multiCityFlightSearchData = valueAccessor().multiCityFlightSearchData;
			templateData.bookerType = valueAccessor().bookerType;
			templateData.closeable = valueAccessor().closeable;
			templateData.uncolapseable = valueAccessor().uncolapseable;
			templateData.collapsed = valueAccessor().collapsed;
			templateData.uncollapseFunction = valueAccessor().uncollapseFunction;
			templateData.links = valueAccessor().links;
			templateData.ydusActive = valueAccessor().ydusActive || false;
			templateData.collapseFunction = valueAccessor().collapseFunction || false;
			templateData.paxpickerParams = valueAccessor().paxpickerParams || false;
			templateData.showPassengerCount = !(valueAccessor().hidePassengerCount || false);
			templateData.cabinClassList = valueAccessor().cabinClassList || false;
			templateData.cabinClass = valueAccessor().cabinClass || false;

			self.isSeeMoreClicked = ko.observable(false);

			self.uncollapseBookers = function() {
				templateData.collapseFunction();
				self.isSeeMoreClicked(true);
			}

			return function() { return { name : 'multicity-booker', data : templateData } };
		},
		
		init : function(element, valueAccessor, allBindings) {
			return ko.bindingHandlers.template.init(element, ko.bindingHandlers['multicity-booker'].makeTemplateValueAccessor(valueAccessor, allBindings, element), allBindings);
		},
		
		update : function(element, valueAccessor, allBindings, viewModel, bindingContext) {
			return ko.bindingHandlers.template.update(element, ko.bindingHandlers['multicity-booker'].makeTemplateValueAccessor(valueAccessor, allBindings, element), allBindings, viewModel, bindingContext);
		}
		
	};
	
	ko.virtualElements.allowedBindings['multicity-booker'] = true;

});
